import contractOtpDictionary from '@widgets/contract-otp/i18n/ru/contract-otp.dic.json';

export const contractOtp = {
  CONTRACT_OTP: contractOtpDictionary,
};

export const contractOtpNamespaces = ['CONTRACT_OTP'];
